/* jshint esversion: 6 */
/* jshint ignore:start */
import axios from 'axios';
import { useContext, useEffect, useState } from 'react';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { Link, useNavigate } from 'react-router-dom';
import { MyContext } from '../../Context/MyProvider';
import { useTranslation } from 'react-i18next';
import Loading from '../Loading';
import secureLocalStorage from "react-secure-storage";
import ImageLoad from '../ImageLoad';

const OurServices = () => {

    const { t } = useTranslation();

    const { ApiBaseUrl, ImgBaseUrl } = useContext(MyContext);

    const [labData, setLabData] = useState([]);
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();

    const NavigateHandle = (title, id) => {
        navigate("/doctor-details");
        sessionStorage.setItem("Docdetails", JSON.stringify({ id: id, title: title, path: "/services", pagename: "Our Services" }));
    };

    useEffect(() => {
        navigator.geolocation.getCurrentPosition(position => {
            const lat = String(position.coords.latitude);
            const long = String(position.coords.longitude);
            fetchHomeData(lat, long);
        });
    }, []);

    const fetchHomeData = (lat, long) => {
        const Userid = secureLocalStorage.getItem("Userid") || "0";
        if (Userid) {
            axios.post(`${ApiBaseUrl}/customer/home`, { id: Userid, lat: lat, lon: long })
                .then((res) => {
                    const { department_list, ResponseCode } = res.data;
                    if (ResponseCode === 200) {
                        setLabData(department_list);
                    }
                    setLoading(false);
                })
                .catch((error) => {
                    console.error("Home Api", error);
                });
        }
    };

    useEffect(() => {
        loading
            ? document.body.style.overflow = "hidden"
            : document.body.style.overflow = "auto";
    }, [loading]);

    return (
        <div className='w-full width-container content-wrapper'>
            {loading
                ? <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white" />
                : <div className="mt-[25px] ourservices">
                    <div className="flex items-center justify-between">
                        <Link to="/" className="flex items-center gap-[5px] border-[2px] border-gray-200 rounded-[50px] px-[10px] group py-[4px] hover:bg-black">
                            <IoIosArrowBack className=' group-hover:text-white' />
                            <h1 className='font-[500] group-hover:text-white'> {t("Go Home")}</h1>
                        </Link>
                        <div className="flex items-center gap-[10px] max-_430_:hidden">
                            <Link to="/" className='font-[500] text-gray-700'>{t("Home")}</Link>
                            <IoIosArrowForward />
                            <h1 className='font-[500] text-gray-400'>{t("Our Services")}</h1>
                        </div>
                        <div className="border-[2px] border-gray-200 rounded-[50px] px-[20px] py-[2px] hidden max-_430_:block">
                            <Link to="/" className='font-[500] text-gray-600'>Back</Link>
                        </div>
                    </div>
                    <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-3 mt-5">
                        {labData.map((item, index) => {
                            return <div onClick={() => NavigateHandle(item.name, item.id)} key={index} className='h-full md:h-[200px] rounded-[15px] border cursor-pointer border-gray-200 hover:border-[#4038FF] hover:shadow-md hover:-translate-y-1 transition-all duration-300 p-[10px] flex flex-col justify-center'>
                                <div className="">
                                    <ImageLoad src={ImgBaseUrl + item.image} CustomeStyle={"w-[100%] h-[100px] md:h-[120px] object-contain mx-auto rounded-[10px]"} alt={"logo"} />
                                </div>
                                <h1 className='font-[500] mt-[15px] text-center whitespace-nowrap overflow-hidden overflow-ellipsis'>{item.name}</h1>
                            </div>
                        })}
                    </div>
                </div>}
        </div>
    )
}

export default OurServices
/* jshint ignore:end */